var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('ShortPresen',{attrs:{"InfoView":_vm.IberoPresen,"TitleRef":_vm.$ml.get('txtIberoPresen')}}),_c('ShortVitual',{attrs:{"InfoView":_vm.IberoVirtual,"TitleRef":_vm.$ml.get('txtIberoVitual')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }